/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
var containerCSSOld = css({
  minHeight: '100px',
  flexBasis: '100%'
});
var containerCSSNew = css({
  padding: "var(--ds-space-100, 8px)",
  minHeight: '100px',
  // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
  display: 'none'
});
var ExtensionFrame = function ExtensionFrame(props) {
  return jsx("div", {
    css: [fg('platform_editor_multi_body_extension_extensibility') ? containerCSSNew : containerCSSOld],
    "data-extension-frame": "true"
  }, props.children);
};
export default ExtensionFrame;